<template>
  <div>
    <div v-if="tabella_principale">
      <v-card class="mx-auto">
        <v-toolbar dense color="rgb(63,81,181)">
          <v-toolbar-title class="white--text">
            Lista Attrezzature
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- PULSANTE AGGIUNGI -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="aggiungiAttrezzatura"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="rgb(25, 118, 210)"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- PULSANTE INDIETRO -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small @click="clickIndietro" v-bind="attrs" v-on="on">
                <v-icon color="rgb(255, 82, 82)">
                  mdi-keyboard-backspace
                </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
      </v-card>

      <template>
        <v-data-table
          fixed-header
          height="300px"
          :items="items_listaattrezzature"
          :headers="headers_listaattrezzature"
        >
          <!-- BOTTONE MODIFICA -->

          <template v-slot:[`item.modifica`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="modificaAttrezzatura(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Modifica</span>
            </v-tooltip>
          </template>

          <!-- BOTTONE MACCHINA IN LISTA -->

          <template v-slot:[`item.macchina`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="assegnaMacchina(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-robot-industrial</v-icon>
                </v-btn>
              </template>
              <span>Macchina</span>
            </v-tooltip>
          </template>

          <!-- BOTTONE AGGIUNGI ALLEGATO ATTREZZATURA -->

          <template v-slot:[`item.allegatiattr`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="aggiungiAllegatoAttrezzatura(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-paperclip </v-icon>
                </v-btn>
              </template>
              <span>Allega Immagine</span>
            </v-tooltip>
          </template>

          <!-- BOTTONE CANCELLA -->

          <template v-slot:[`item.cancella`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="clickElimina(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Disattiva</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <!-- Dialog degli allegati -->

      <v-dialog v-model="allegati_attrezzature_visible">
        <GestioneAllegato
          @click_chiudi="allegati_attrezzature_visible = false"
          controller_allegati="Global"
          controller_caratteristiche_tabella="Manutenzione"
          :id_riferimento="id_attrezzatura"
          :read_only="false"
          ref="componenteAllegatiAttrezzatura"
          @salva_allegati="salvaAllegatiAttrezzatura"
          :show_save_button="true"
          @snackbarOpen="snackbarOpen"
          tipo_allegato="ALLEGATI_ATTREZZATURA"
        />
      </v-dialog>

      <!-- DIALOG DI CONFERMA ELIMINAZIONE RIGA -->

      <v-dialog v-model="conferma_eliminazione" width="unset">
        <v-card style="max-width: 500px">
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Eliminazione
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="elimina" small>
              <v-icon color="success"> mdi-check </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn class="mr-5" @click="conferma_eliminazione = false" small>
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="color: rgb(0, 0, 0); font-size: 18px">
              Confermi di voler disattivare l'attrezzatura selezionata?
            </span>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />
    </div>

    <!-- TABELLA GENERALE -->

    <div v-if="tabella_generale">
      <v-card class="mx-auto">
        <v-toolbar dense color="rgb(63,81,181)">
          <v-toolbar-title class="white--text">
            Dati Attrezzatura
          </v-toolbar-title>

          <!-- PULSANTE SALVA -->

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                small
                @click="salvaAttrezzatura"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="rgb(76, 175, 80)"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <!-- PULSANTE CHIUDI -->

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                small
                @click="chiudiAttrezzatura"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="rgb(255, 82, 82)">
                  mdi-keyboard-backspace
                </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>

        <!--TABELLA -->

        <v-container>
          <v-row>
            <v-col class="py-0" cols="4" md="3">
              <v-text-field
                v-model="listaattrezzi_sel.cod_atr"
                label="Cod. Attrezzatura"
                placeholder="Inserisci il codice"
              ></v-text-field>
            </v-col>

            <v-col class="py-0" cols="6" md="5">
              <v-text-field
                v-model="listaattrezzi_sel.des"
                label="Descrizione"
                placeholder="Inserisci la descrizione"
              ></v-text-field>
            </v-col>

            <v-col class="py-0" cols="6" md="4">
              <v-text-field
                v-model="listaattrezzi_sel.alt_des"
                label="Altra Descrizione"
                placeholder="Inserisci altra descrizione"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="6" md="3">
              <v-autocomplete
                v-model="listaattrezzi_sel.tipo"
                :items="attrezzi"
                label="Tipo Attrezzatura"
                placeholder="Tipo Attrezzatura"
              >
              </v-autocomplete>
            </v-col>

            <v-col class="py-0" cols="6" md="3">
              <v-autocomplete
                v-model="listaattrezzi_sel.sub_tipo"
                label="Sub Tipo Attr."
                :items="subattrezzaturaList"
                item-text="des"
                item-value="id_tabella"
                ><template #label>
                  <span class="">Sub Tipo Attrezzatura<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="aggiornaFamiglia"
                      tipo="SUB_TIPO_ATTREZZATURA"
                      nome="Sub Tipo Attrezzatura"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="py-0" cols="6" md="3">
              <v-autocomplete
                v-model="listaattrezzi_sel.famig"
                placeholder="Tipo Famiglia"
                item-text="des"
                item-value="id_tabella"
              >
                <template #label>
                  <span class="">Famiglia<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="aggiornaSubtipoAttrezzatura"
                      tipo="SUB_TIPO_ATTREZZATURA"
                      nome="Famiglia"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a> </template
              ></v-autocomplete>
            </v-col>

            <v-col class="py-0" cols="6" md="3">
              <v-autocomplete
                v-model="listaattrezzi_sel.sub_famig"
                placeholder="Sub Famiglia Attrezzatura"
                item-text="des"
                item-value="id_tabella"
              >
                <template #label>
                  <span class="">Sub Famiglia<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="aggiornaSubFamiglia"
                      tipo="SUB_FAMIGLIA_ATTREZZATURA"
                      nome="Sub Famiglia"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0" cols="6" md="3">
              <v-autocomplete
                v-model="listaattrezzi_sel.costr"
                ref="costruttore"
                item-text="des"
                item-value="id_tabella"
                placeholder="Seleziona il costruttore"
              >
                <template #label>
                  <span class="">Costruttore<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="aggiornaCostruttore"
                      tipo="COSTRUTTORE"
                      nome="Costruttore"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="py-0" cols="6" md="3">
              <v-menu
                v-model="calendario_data_da"
                :close-on-content-click="false"
                :nudge-right="40"
                min-width="289"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <div
                    class="mr-5"
                    style="
                      display: inline-block;
                      background-color: white;
                      padding: 3px;
                    "
                  >
                    <v-text-field
                      hide-details
                      label="Data Costruzione"
                      v-model="data_da_formattata"
                      readonly
                      v-on="on"
                    >
                    </v-text-field>
                  </div>
                </template>
                <v-date-picker
                  v-model="data_da"
                  @input="calendario_data_da = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>

    <!-- TABELLA MACCHINARIO -->

    <div v-if="tabella_macchinario">
      <v-card class="mx-auto">
        <v-toolbar dense color="rgb(63,81,181)">
          <v-toolbar-title class="white--text"> Macchinario </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- PULSANTE AGGIUNGI MACCHINARIO -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                small
                @click="aggiungiMacchina"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="rgb(25, 118, 210)"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- PULSANTE CHIUDI MACCHINARIO -->

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                small
                @click="chiudiMacchinario"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="rgb(255, 82, 82)">
                  mdi-keyboard-backspace
                </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
      </v-card>
      <template>
        <v-data-table
          fixed-header
          height="300px"
          :items="items_listamacchina"
          :headers="headers_listamacchina"
        >
          <!-- BOTTONE MODIFICA -->

          <template v-slot:[`item.modificamacchina`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="modificaMacchina(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Modifica M</span>
            </v-tooltip>
          </template>

          <!-- BOTTONE AGGIUNGI ALLEGATO-->

          <template v-slot:[`item.allegati`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="aggiungiAllegatoMacchina(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-paperclip </v-icon>
                </v-btn>
              </template>
              <span>Allega Immagine</span>
            </v-tooltip>
          </template>

          <!-- BOTTONE AGGIUNGI ISTRUZIONI-->

          <template v-slot:[`item.istr`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="aggiungiIstruzioni(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">
                    mdi-format-list-bulleted-square
                  </v-icon>
                </v-btn>
              </template>
              <span>Istruzioni</span>
            </v-tooltip>
          </template>

          <!-- BOTTONE AGGIUNGI ADDETTI-->

          <template v-slot:[`item.addetti`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="aggiungiAddetto(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-account </v-icon>
                </v-btn>
              </template>
              <span>Addetti</span>
            </v-tooltip>
          </template>

          <!-- BOTTONE CANCELLA -->

          <template v-slot:[`item.cancellamacchina`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="clickEliminaMacchina(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Disattiva</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <!-- Dialog degli allegati -->

      <v-dialog v-model="allegati_macchina_visible">
        <GestioneAllegato
          @click_chiudi="allegati_macchina_visible = false"
          controller_allegati="Global"
          controller_caratteristiche_tabella="Manutenzione"
          :id_riferimento="id_macchinario"
          :read_only="false"
          ref="componenteMacchinario"
          @salva_allegati="salvaAllegatiMacchina"
          :show_save_button="true"
          @snackbarOpen="snackbarOpen"
          tipo_allegato="ALLEGATI_MACCHINA"
        />
      </v-dialog>

      <!-- DIALOG AGGIUNGI MACCHINARIO -->

      <v-dialog persistent v-model="macchina_articolo" max-width="800px">
        <v-card class="mx-auto">
          <v-toolbar dense color="rgb(63,81,181)">
            <v-toolbar-title class="white--text"> Macchinario </v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- PULSANTE SALVA DIALOG MACCHINARIO -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="salvaMacchinario"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="rgb(76, 175, 80)"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!-- PULSANTE CHIUDI DIALOG MACCHINARIO -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="chiudiDialogMacchinario"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="rgb(255, 82, 82)"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col class="py-0" cols="6" md="6">
                <v-autocomplete
                  ref="macchinario"
                  :items="macchinalist"
                  item-text="des_macchina"
                  item-value="id_macchina"
                  label="Macchinario"
                  placeholder="Seleziona il macchinario"
                ></v-autocomplete>
              </v-col>

              <v-col class="py-0" cols="6" md="6">
                <v-autocomplete
                  ref="articolo"
                  :items="articoli"
                  item-text="cod_articolo"
                  item-value="id_articolo"
                  label="Articolo"
                  placeholder="Seleziona Articolo"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- DIALOG DI CONFERMA ELIMINAZIONE DI UNA MACCHINA -->

      <v-dialog v-model="conferma_eliminazione_macchina" width="unset">
        <v-card style="max-width: 500px">
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Eliminazione
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="eliminaMacchina" small>
              <v-icon color="success"> mdi-check </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-5"
              @click="conferma_eliminazione_macchina = false"
              small
            >
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="color: rgb(0, 0, 0); font-size: 18px">
              Confermi di voler disattivare il macchinario selezionato?
            </span>
            <v-container>
              <v-row align="center" justify="center">
                <v-col class="my-0 py-0" justify="center" cols="12"> </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOG ISTRUZIONI -->

      <v-dialog v-model="istruzioni_lista">
        <v-card elevation="2" class="mx-0 pa-0">
          <v-card-text class="ma-0 pa-0">
            <v-data-table
              :headers="headers_istruzioni"
              :items="
                items_istruzioni != null
                  ? items_istruzioni.filter((e) => e.validita === 1)
                  : []
              "
              height="50vh"
              fixed-header
            >
              <template v-slot:top>
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Istruzioni
                  </v-toolbar-title>

                  <v-spacer></v-spacer>

                  <!-- Pulsante di aggiunta istruzione -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="aggiungiIstruzione"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Aggiungi Istruzione</span>
                  </v-tooltip>

                  <v-spacer></v-spacer>

                  <!-- BOTTONE CHIUDI -->

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        @click="chiudiIstruzione"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error"> mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Chiudi</span>
                  </v-tooltip>
                </v-toolbar>
              </template>

              <!-- Colonna dell'indice -->
              <template v-slot:[`item.indice`]="{ item }">
                <b>{{ item.indice }}</b>
              </template>

              <!-- Bottone di modifica delle istruzioni -->
              <template v-slot:[`item.modifica`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="modificaIstruzione(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </template>
                  <span>Modifica Istruzione</span>
                </v-tooltip>
              </template>

              <!-- Bottone di eliminazione delle istruzioni -->

              <template v-slot:[`item.elimina`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="clickEliminaIstruzione(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina Istruzione</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di conferma eliminazione istruzione -->

      <v-dialog v-model="conf_del_ins_dialog" width="500px">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Eliminazione
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="eliminaIstruzione" small>
              <v-icon color="success">mdi-check</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn class="mr-5" @click="conf_del_ins_dialog = false" small>
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="color: rgb(0, 0, 0); font-size: 18px">
              Confermi di voler eliminare l'istruzione selezionata?
            </span>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di modifica dell'istruzione -->

      <v-dialog v-model="modifica_istruzione_dialog" width="500px">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Modifica Istruzione
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="salvaIstruzione" small v-bind="attrs" v-on="on">
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva Istruzione</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="chiudiModificaIstruzione"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" align="center">
                  <v-text-field
                    v-model="istruzione_sel.des_istruzione"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOG ADDETTI -->

      <v-dialog v-model="aggiungi_addetto" width="800px">
        <v-card elevation="2" class="mx-0 pa-0">
          <v-card-text class="ma-0 pa-0">
            <v-data-table
              :headers="headers_addetti"
              :items="items_addetti"
              height="50vh"
              fixed-header
            >
              <template v-slot:top>
                <v-toolbar color="indigo" dense>
                  <v-toolbar-title class="white--text">
                    Addetti
                  </v-toolbar-title>

                  <v-spacer></v-spacer>

                  <!-- Pulsante di aggiunta addetto -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="aggiungi_utente = true"
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="primary"> mdi-plus </v-icon>
                      </v-btn>
                    </template>
                    <span>Aggiungi Addetto</span>
                  </v-tooltip>

                  <v-spacer></v-spacer>

                  <!-- BOTTONE CHIUDI -->

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        @click="chiudiAddetto"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="error"> mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Chiudi</span>
                  </v-tooltip>
                </v-toolbar>
              </template>

              <!-- Bottone di eliminazione degli addetti -->

              <template v-slot:[`item.elimina`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="clickEliminaAddetto(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Rimuovi Addetto</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Dialog di conferma eliminazione addetto -->

      <v-dialog v-model="conferma_eliminazione_addetto" width="500px">
        <v-card>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text"> Rimozione </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="rimuoviAddetto" small>
              <v-icon color="success">mdi-check</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-5"
              @click="conferma_eliminazione_addetto = false"
              small
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="mt-5" style="overflow-y: auto">
            <span style="color: rgb(0, 0, 0); font-size: 18px">
              Confermi di voler rimuovere l'addetto selezionato?
            </span>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!--DIALOG SELEZIONE UTENTE-->

      <v-dialog v-model="aggiungi_utente" width="500px">
        <v-card class="mx-auto">
          <v-toolbar dense color="rgb(63,81,181)">
            <v-toolbar-title class="white--text"> Addetto </v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- PULSANTE SALVA DIALOG ADDETTO -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="salvaAddetto"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="rgb(76, 175, 80)"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <!-- PULSANTE CHIUDI DIALOG UTENTE -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mr-5"
                  small
                  @click="aggiungi_utente = false"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="rgb(255, 82, 82)"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col class="py-0" cols="8" md="7">
                <v-autocomplete
                  ref="Addetto"
                  :items="addettolist"
                  :item-text="
                    (item) => `${item.id_utente} ${item.nome} ${item.cognome}`
                  "
                  item-value="id_utente"
                  label="Addetto"
                  placeholder="Seleziona l'addetto"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import GestioneAllegato from "@/components/TOOLS/GestioneAllegato.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Listaattrezzi {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod_atr", default_val: "" },
      { nome: "des", default_val: "" },
      { nome: "alt_des", default_val: "" },
      { nome: "tipo", default_val: "" },
      { nome: "sub_tipo", default_val: "" },
      { nome: "famig", default_val: "" },
      { nome: "sub_famig", default_val: "" },
      { nome: "data_costr", default_val: "" },
      { nome: "costr", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class Listamacchina {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const mac = this.setMacchina();
      mac.forEach((m) => {
        this[m.nome] = arg[m.nome] != undefined ? arg[m.nome] : m.default_val;
      });
    } else {
      const mac = this.setMacchina();
      mac.forEach((m) => {
        this[m.nome] = m.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const mac = this.setMacchina();

    mac.forEach((m) => {
      this[m.nome] = m.default_val;
    });
  }

  setMacchina() {
    const mac = [
      { nome: "macchi", default_val: "" },
      { nome: "articolo", default_val: "" },
      { nome: "allegato", default_val: "" },
      { nome: "istr", default_val: "" },
      { nome: "addetto", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return mac;
  }
}

class Istruzione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des_istruzione", default_val: "" },
      { nome: "id_pack_istruzioni", default_val: -1 },
      { nome: "indice", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class Addetti {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_utente", default_val: "" },
      { nome: "nome", default_val: -1 },
      { nome: "cognome", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "App",
components: {
    Modules: () => import("@/components/TOOLS/Modules"),
    SnackbarQV,
    GestioneAllegato,
  },

  data() {
    return {
      addettolist: [],
      articoli: [],
      associazioni: [],
      attrezzi: ["Attrezzatura"],
      data: "",
      data_da: "",
      headers_addetti: [
        {
          text: "Id Addetto",
          value: "id_utente",
          width: "100px",
          sortable: false,
        },
        { text: "Cognome", value: "cognome", sortable: false },
        { text: "Nome", value: "nome", sortable: false },
        { text: " ", value: "elimina", width: "50px", sortable: false },
      ],

      headers_listaattrezzature: [
        { text: " ", value: "modifica", sortable: false, width: "80px" },
        { text: " ", value: "macchina", sortable: false, width: "80px" },
        { text: " ", value: "allegatiattr", sortable: false, width: "80px" },
        { text: "Codice Atr.", value: "cod_atr", sortable: false },
        { text: "Descrizione", value: "des", sortable: false },
        { text: "Famiglia", value: "famig", sortable: false },
        { text: "Data Costruzione", value: "data_costr", sortable: false },
        { text: "Costruttore", value: "costr", sortable: false },
        { text: " ", value: "cancella", sortable: false, width: "80px" },
      ],

      headers_istruzioni: [
        { text: " ", value: "modifica", width: "50px", sortable: false },
        { text: "Indice", value: "indice", width: "150px", sortable: false },
        { text: "Des. Istruzione", value: "des_istruzione", sortable: false },
        { text: " ", value: "elimina", width: "50px", sortable: false },
      ],

      headers_listamacchina: [
        {
          text: " ",
          value: "modificamacchina",
          sortable: false,
          width: "50px",
        },
        { text: " ", value: "allegati", sortable: false, width: "50px" },
        { text: " ", value: "istr", sortable: false, width: "50px" },
        { text: " ", value: "addetti", sortable: false, width: "50px" },
        { text: "Macchinario", value: "macchi", sortable: false },
        { text: "Articolo", value: "articolo", sortable: false },
        {
          text: " ",
          value: "cancellamacchina",
          sortable: false,
          width: "50px",
        },
      ],
      id_attrezzatura: null,
      id_macchinario: null,
      items_addetti: [[]],
      items_listaattrezzature: [[]],
      items_listamacchina: [[]],
      macchinalist: [],

      aggiungi_addetto: false,
      aggiungi_utente: false,
      allegati_attrezzature_visible: false,
      allegati_macchina_visible: false,
      calendario_data_da: false,
      conferma_eliminazione: false,
      conferma_eliminazione_addetto: false,
      conferma_eliminazione_macchina: false,
      conf_del_ins_dialog: false,
      istruzioni_lista: false,
      macchina_articolo: false,
      modifica_istruzione_dialog: false,
      tabella_principale: true,
      tabella_generale: false,
      tabella_macchinario: false,

      // Array
      addetti_sel: new Addetti(),
      costruttoreList: new Array(),
      dataCostruzioneList: new Array(),
      famigliaList: new Array(),
      istruzione_sel: new Istruzione(),
      items_istruzioni: new Array(),
      listaattrezzi_sel: new Listaattrezzi(),
      listamacchina_sel: new Listamacchina(),
      subattrezzaturaList: new Array(),
      subfamigliaList: new Array(),
    };
  },

    computed: {
    data_da_formattata() {
      return this.data_da != ""
        ? moment(this.data_da).format("DD/MM/YYYY")
        : "";
    },
  },


  methods: {
    aggiornaCostruttore() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "COSTRUTTORE",
          filter: `validita = 1`,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.costruttoreList = res.data;
      });
    },

    aggiornaDataCostruzione() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "DATA_COSTRUZIONE",
          filter: `validita = 1`,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.dataCostruzioneList = res.data;
      });
    },

    aggiornaFamiglia() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "FAMIGLIA",
          filter: `validita = 1`,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.famigliaList = res.data;
      });
    },

    aggiornaSubFamiglia() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "SUB_FAMIGLIA_ATTREZZATURA",
          filter: `validita = 1`,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.subFamigliaList = res.data;
      });
    },

    aggiornaSubtipoAttrezzatura() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "SUB_TIPO_ATTREZZATURA",
          filter: `validita = 1`,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.subattrezzaturaList = res.data;
      });
    },

    aggiungiAddetto() {
      this.aggiungi_addetto = true;
    },

    aggiungiAllegatoAttrezzatura(arg) {
      this.id_attrezzatura = arg.id_attrezzatura;
      this.allegati_attrezzature_visible = true;
    },

    aggiungiAllegatoMacchina(arg) {
      this.id_macchinario = arg.id_macchinario;
      this.allegati_macchina_visible = true;
    },

    aggiungiAttrezzatura() {
      this.tabella_principale = false;
      this.tabella_generale = true;
      this.tabella_macchinario = false;
    },

    aggiungiIstruzione() {
      this.istruzione_sel = new Istruzione();
      this.modifica_istruzione_dialog = true;
    },

    aggiungiIstruzioni() {
      this.istruzioni_lista = true;
    },

    aggiungiMacchina() {
      this.macchina_articolo = true;
    },

    assegnaMacchina() {
      this.tabella_principale = false;
      this.tabella_generale = false;
      this.tabella_macchinario = true;
    },

    chiudiAddetto() {
      this.aggiungi_addetto = false;
    },

    chiudiAttrezzatura() {
      this.tabella_principale = true;
      this.tabella_generale = false;
      this.tabella_macchinario = false;
    },

    chiudiDialogMacchinario() {
      this.macchina_articolo = false;
    },

    chiudiIstruzione() {
      this.istruzioni_lista = false;
    },

    chiudiMacchinario() {
      this.tabella_principale = true;
      this.tabella_generale = false;
      this.tabella_macchinario = false;
    },

    chiudiModificaIstruzione() {
      this.istruzione_sel = new Istruzione();
      this.modifica_istruzione_dialog = false;
    },

    clickElimina(arg) {
      this.listaattrezzi_sel = new Listaattrezzi(arg);
      this.conferma_eliminazione = true;
    },

    clickEliminaAddetto(arg) {
      this.addetti_sel = new Addetti(arg);
      this.conferma_eliminazione_addetto = true;
    },

    clickEliminaIstruzione(arg) {
      this.istruzione_sel = new Istruzione(arg);
      this.conf_del_ins_dialog = true;
    },

    clickEliminaMacchina(arg) {
      this.listamacchina_sel = new Listamacchina(arg);
      this.conferma_eliminazione_macchina = true;
    },

    clickIndietro() {
      this.$router.push("/home");
    },
    elimina() {
      const listaattrezzi_tmp = new Listaattrezzi(this.listaattrezzi_sel);
      listaattrezzi_tmp.validita = 0;
    },

    eliminaIstruzione() {
      for (let i = 0; i < this.items_istruzioni.length; i++) {
        if (
          this.items_istruzioni[i].id_pack_istruzioni ===
          this.istruzione_sel.id_pack_istruzioni
        ) {
          this.items_istruzioni[i].validita = 0;
        }
      }

      this.conf_del_ins_dialog = false;
      this.istruzione_sel = new Istruzione();
      this.setIndiceRicorsivo(this.items_istruzioni);
    },

    eliminaMacchina() {
      const listamacchina_tpm = new Listamacchina(this.listamacchina_sel);
      listamacchina_tpm.validita = 0;
    },

    getAddettiList() {
      let request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getUtenti",
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.addettolist = res.data.result.utenti;
      });
    },

    getMacchinariList() {
      let request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.macchinalist = res.data.macchine;
      });
    },

    getTabelle() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'SUB_TIPO_ATTREZZATURA', 'FAMIGLIA','SUB_FAMIGLIA_ATTREZZATURA','DATA_COSTRUZIONE','COSTRUTTORE'",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.subattrezzaturaList =
          res.data.SUB_TIPO_ATTREZZATURA != undefined
            ? res.data.SUB_TIPO_ATTREZZATURA
            : [];
        this.famigliaList =
          res.data.FAMIGLIA != undefined ? res.data.FAMIGLIA : [];
        this.subfamigliaList =
          res.data.SUB_FAMIGLIA_ATTREZZATURA != undefined
            ? res.data.SUB_FAMIGLIA_ATTREZZATURA
            : [];
        this.dataCostruzioneList =
          res.data.DATA_COSTRUZIONE != undefined
            ? res.data.DATA_COSTRUZIONE
            : [];
        this.costruttoreList =
          res.data.COSTRUTTORE != undefined ? res.data.COSTRUTTORE : [];
      });
    },

    modificaAttrezzatura(arg) {
      this.listaattrezzi_sel = new Listaattrezzi(arg);
      this.tabella_principale = false;
      this.tabella_generale = true;
      this.tabella_macchinario = false;
    },
    modificaIstruzione(arg) {
      this.istruzione_sel = new Istruzione(arg);
      this.modifica_istruzione_dialog = true;
    },
    modificaMacchina(arg) {
      this.listamacchina_sel = new Listamacchina(arg);
      this.macchina_articolo = true;
    },

    rimuoviAddetto(){
      
    },

    salvaAllegatiAttrezzatura() {
      // Salvo gli allegati dell'intervento.
      this.$refs.componenteAllegatiAttrezzatura.id_riferimento_creazione_genitore =
        this.id_attrezzatura;
      this.$refs.componenteAllegatiAttrezzatura.salvaTuttiAllegati();

      // Chiudo il dialog degli allegati.
      this.allegati_attrezzature_visible = false;
    },
    salvaAllegatiMacchina() {
      // Salvo gli allegati dell'intervento.
      this.$refs.componenteAllegatiMacchina.id_riferimento_creazione_genitore =
        this.id_macchinario;
      this.$refs.componenteAllegatiMacchina.salvaTuttiAllegati();

      // Chiudo il dialog degli allegati.
      this.allegati_macchina_visible = false;
    },

    salvaAttrezzatura() {
      this.tabella_principale = true;
      this.tabella_generale = false;
      this.tabella_macchinario = false;
    },

    salvaIstruzione() {
      if (this.istruzione_sel.id_pack_istruzioni === -1) {
        this.istruzione_sel.id_pack_istruzioni = -moment().valueOf();
        this.items_istruzioni.push(Object.assign({}, this.istruzione_sel));
      } else {
        for (let i = 0; i < this.items_istruzioni.length; i++) {
          if (
            this.items_istruzioni[i].id_pack_istruzioni ===
            this.istruzione_sel.id_pack_istruzioni
          ) {
            this.$set(
              this.items_istruzioni,
              i,
              Object.assign({}, this.istruzione_sel)
            );
          }
        }
      }

      this.setIndiceRicorsivo(this.items_istruzioni);

      this.modifica_istruzione_dialog = false;
    },

    salvaMacchinario() {
      this.tabella_principale = false;
      this.tabella_generale = false;
      this.tabella_macchinario = true;
    },

    searchArticolo() {
      let search_Articolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.getItem("user_token"),
          cod_articolo: "*",
          id_famiglia: "",
          id_tipo: "",
          id_tipo_fornitura: "",
          validita: 1,
        },
      };

      this.$store.dispatch("api", search_Articolo).then((res) => {
        this.articoli = res.data.lista;
      });
    },

    setIndiceRicorsivo(array) {
      let indice = 0;

      for (let i = 0; i < array.length; i++) {
        if (array[i].validita === 1) {
          indice = indice + 1;
          array[i].indice = indice;
        }
      }
    },

    snackbarOpen() {
      //funzione triggerata per cogliere l' errore degli allegati che non hanno la descrizione inserita
      this.$refs.SnackbarQV.print(
        "orange",
        "Aggiungere ad ogni Allegato dell'attività una descrizione."
      );
    },
  },
  mounted() {
    this.data_a = moment().format("YYYY-MM-DD");
    this.data_da = moment().subtract(7, "days").format("YYYY-MM-DD");
    this.searchArticolo();
    this.getMacchinariList();
    this.getAddettiList();
  },
  

};
</script>
